export default "__VITE_ASSET__DScUwSYz__"